import React from "react"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { i18nContext } from "../context/i18nContext"
import { getArticlePath, getPagePath, getBlogPath } from "../utils/path"
import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  Image,
} from "@theme-ui/components"
import { GatsbyImage } from "gatsby-plugin-image"
import { InboundLink } from "../components/link"
import ArrowWhite from "../images/list-arrow-white.svg"

const ArticleHero = ({ article }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  const formatDate = dateString => {
    // Se la stringa contiene mesi italiani, parsala
    if (typeof dateString === "string" && dateString.includes(" ")) {
      const monthNames = {
        gennaio: "01",
        febbraio: "02",
        marzo: "03",
        aprile: "04",
        maggio: "05",
        giugno: "06",
        luglio: "07",
        agosto: "08",
        settembre: "09",
        ottobre: "10",
        novembre: "11",
        dicembre: "12",
      }

      const parts = dateString.split(" ")
      if (parts.length === 3) {
        const day = parts[0].padStart(2, "0")
        const month = monthNames[parts[1].toLowerCase()]
        const year = parts[2]

        if (month) {
          return `${day}.${month}.${year}`
        }
      }
    }

    // Fallback per date raw
    const date = new Date(dateString)
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}.${month}.${year}`
  }
  console.log(article.meta.firstPublishedAt)

  return (
    <i18nContext.Consumer>
      {t => (
        <Box>
          {/* MOBILE */}
          <Container
            sx={{
              mt: 5,
              display: ["block", "block", "none", "none"],
              padding: [3, 3, 3, 4],
            }}
          >
            <Text
              variant="kicker"
              sx={{ color: "primary", borderColor: "primary" }}
            >
              {formatDate(article.meta.firstPublishedAt)}
            </Text>
            <Heading
              sx={{
                mt: [4],
                fontSize: [5, "48px"],
                color: "primary",
                fontWeight: 500,
                width: ["100%", "100%", "50%"],
                lineHeight: 1.2,
              }}
            >
              <InboundLink
                to={getArticlePath(article, locale)}
                sx={{ textDecoration: "none", color: "inherit" }}
              >
                {article.title}
              </InboundLink>
            </Heading>
            <Box
              sx={{
                mt: [4],
                position: "relative",
                height: ["220px"],
              }}
            >
              <Box
                sx={{
                  borderRadius: ["30px", "60px"],
                  overflow: "hidden",
                  display: "flex",
                  height: "100%",
                }}
              >
                {article.heroImage && (
                  <InboundLink to={getArticlePath(article, locale)}>
                    <GatsbyImage
                      image={article.heroImage.gatsbyImageData}
                      alt={article.title}
                      style={{ height: "100%", width: "100%" }}
                    />
                  </InboundLink>
                )}
              </Box>
            </Box>
          </Container>

          {/* DESKTOP */}
          <Container
            sx={{
              mt: [7, 7, 7, 9],
              position: "relative",
              display: ["none", "none", "block", "block"],
            }}
          >
            <Box
              sx={{
                overflow: "hidden",
                height: ["640px"],
                ".gatsby-image-wrapper": {
                  borderRadius: "80px",
                },
              }}
            >
              {article.heroImage && (
                <GatsbyImage
                  image={article.heroImage.gatsbyImageData}
                  alt={article.title}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                  }}
                />
              )}
              <Flex
                sx={{
                  position: "relative",
                  padding: "13px",
                  width: "100%",
                  height: "100%",
                  zIndex: 2,
                  fontSize: "15px",

                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <InboundLink
                  to={getBlogPath(locale)}
                  variant="kicker"
                  sx={{
                    borderColor: "white",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderRadius: "40px",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "white",
                    textDecoration: "none",
                    fontWeight: 500,
                    textTransform: "uppercase",
                    fontSize: "14px",
                    width: "fit-content",
                    transition: "all 0.3s ease",
                    ":hover": {
                      backgroundColor: "white",
                      color: "black",
                      img: {
                        filter: "brightness(0)",
                      },
                    },
                  }}
                >
                  <Image
                    src={ArrowWhite}
                    sx={{
                      maxWidth: "40px",
                      transform: "rotate(180deg)",
                      transition: "all 0.3s ease",
                    }}
                  />
                  <Text
                    sx={{
                      color: "inherit",
                      borderColor: "inherit",
                      fontWeight: "inherit",
                      textTransform: "inherit",
                      fontSize: "inherit",
                    }}
                  >
                    Vedi tutti
                  </Text>
                </InboundLink>
                <Flex
                  sx={{
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <Text
                    sx={{
                      color: "primary",
                      borderColor: "white",
                      fontWeight: 500,
                      lineHeight: 1.15,
                      fontSize: "16px",
                      textTransform: "uppercase",
                    }}
                  >
                    {formatDate(article.meta.firstPublishedAt)}
                  </Text>
                  {article.category && article.category.link && (
                    <InboundLink
                      to={getPagePath(article.category.link, locale)}
                      sx={{
                        textDecoration: "none",
                        color: "inherit",
                        lineHeight: 1.15,
                        fontSize: "16px",
                        color: "light",
                        borderColor: "light",
                        fontWeight: 500,
                        fontSize: "16px",
                        lineHeight: 1.15,
                        width: "fit-content",
                        color: "primary",
                        textTransform: "uppercase",
                        ":hover": {
                          textDecoration: "underline",
                          color: "primary",
                        },
                      }}
                    >
                      {article.category.title}
                    </InboundLink>
                  )}
                  <Heading
                    sx={{
                      fontSize: "48px",
                      color: "white",
                      fontWeight: 500,
                      lineHeight: 1.15,

                      width: ["100%", "100%", "100%", "50%"],
                      lineHeight: 1.2,
                    }}
                  >
                    {article.title}
                  </Heading>
                </Flex>
              </Flex>
            </Box>
          </Container>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}
export default ArticleHero
